import { Component } from '@angular/core';
import { TestDynamicComponent, TestDynamicType } from '../../common/test-dynamic/test-dynamic.component';

@Component({
  selector: 'app-layer-set',
  templateUrl: '../../common/test-dynamic/test-dynamic.component.html',
  styleUrls: ['../../common/test-dynamic/test-dynamic.component.css']
})
export class LayerSetComponent extends TestDynamicComponent {

  getTestDynamicType(): TestDynamicType {
    return TestDynamicType.LAYERS;
  }

  getTitle(): string {
    return 'Validate completeness of dynamic image set';
  }

  getSubmitLabel(): string {
    return 'Validate';
  }

}
